
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('path',{attrs:{"d":"M15 34h14c1.103 0 2-.897 2-2V15c0-1.103-.897-2-2-2h-4c0-1.655-1.345-3-3-3-1.654 0-3 1.345-3 3h-4c-1.103 0-2 .897-2 2v17c0 1.103.897 2 2 2zm6-21a1.001 1.001 0 012 0v1a1 1 0 001 1h1v2h-6v-2h1a1 1 0 001-1v-1zm-6 2h2v2c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-2h2v17H15V15z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    